import React, { Component } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import Fade from "react-reveal/Fade";

class MultiSelectPaginate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: [],
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(newValue) {
    this.setState({ value: newValue }, () => {
      this.props.setValueFilters(this.props.title, this.state.value);
    });
  }

  render() {
    return (
      <div>
        <Fade left opposite>
          <span style={{ fontSize: "11px", fontWeight: "bold" }}>
            {" "}
            <label>{this.props.title}</label>
          </span>
        </Fade>
        <AsyncPaginate
          value={this.state.value}
          loadOptions={this.props.loadOptions}
          isMulti
          closeMenuOnSelect={false}
          onChange={this.handleChange}
          placeholder={""}
          loadingMessage={() => "Cargando ..."}
          noOptionsMessage={() => "Sin opciones"}
          additional={{
            title: this.props.title,
            page: 1,
            clients: this.props.clients,
          }}
        />
      </div>
    );
  }
}

export default MultiSelectPaginate;
